import React, { createContext, useContext, useState } from 'react';
import {SMA_PORTFOLIO_CONFIG} from "../Configs/SmaPortfolioConfig";

const PortfolioContext = createContext();

export const usePortfolio = () => useContext(PortfolioContext);

export const PortfolioProvider = ({ children }) => {
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [smaPortfolio, setSmaPortfolio] = useState(null);
    // Combine all related state into a single object for easier updates
    const [config, setConfig] = useState({...SMA_PORTFOLIO_CONFIG});

    // Generalized update function
    const updateConfig = (key, value) => {
        setConfig(prevConfig => ({
            ...prevConfig,
            [key]: value
        }));
    };

    const selectPortfolio = (portfolio) => {
        setSelectedPortfolio(portfolio);
    };

    const selectSmaPortfolio = (portfolio) => {
        setSmaPortfolio(portfolio);
    };

    const resetSmaPortfolio = () => {
        setSelectedPortfolio(null);
        setSmaPortfolio(null);
        setConfig({...SMA_PORTFOLIO_CONFIG}); // Reset to initial config
    };

    return (
        <PortfolioContext.Provider value={{
            selectedPortfolio,
            selectPortfolio,
            smaPortfolio,
            selectSmaPortfolio,
            resetSmaPortfolio,
            config, // Directly pass the config object
            updateConfig // Pass the new, generalized update function
        }}>
            {children}
        </PortfolioContext.Provider>
    );
};
